import React from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import hljs from 'highlight.js';
import javascript from  'highlight.js/lib/languages/javascript'
import 'highlight.js/styles/dark.css'
import LinkButton from './LinkButton';

class Home extends React.Component{
    constructor(props){
        super(props)
        this.state={
            update:false
        }
        window.addEventListener('resize',this.handleSrceenResize)
    }
    //this is to handle srceen resize event
    handleSrceenResize=()=>{
        this.setState({
            update:(!this.state.update)
        })
    }

    renderFeatures=()=>{
        let features=[
            {
                title:"Light weight",
                image:"light.png",
                text:"Actumjs is small enough to fit in just 5kb.Making it easy to load and  compile at run time.Being small in size actumjs require minimum resources to work."
            },
            {
                title:'Easy to use',
                image:"easy.png",
                text:'State management libraries for javascript require you to have some level of expertise with programming to use it.whereas you can start using Actumjs with very basic programming  skills'
            },{
                title:'Portable',
                image:"portable.png",
                text:'Actumjs provides you the way to create applications that execute seamlessly.'
            }
        ]
      return  <Grid container   style={{padding: '50px 10px 50px 10px',background: '#f1f0ff',justifyContent:'space-around'}}>
                    {
                            features.map((feature,index)=>{
                           return <Grid key={index} item md={6} sm={6} lg={3} xs={12}  style={{display: 'flex',justifyContent: 'center',alignItems: 'center',padding: '5px',marginTop:'20px'}} >
                                <Paper>
                                    <div style={{width: '250px',height: '320px',padding: '10px',display: 'flex',justifyContent: 'center',alignItems: 'center',flexDirection: 'column'}}>
                                        <div>
                                            <img src={"images/"+feature.image} style={{width: '200px'}}/>
                                        </div>
                                        <div>
                                            <Typography variant='h5'>{feature.title}</Typography>
                                        </div>
                                        <div style={{padding:'10px'}}>
                                            <Typography variant='subtitle2'>
                                                {feature.text}
                                            </Typography>
                                        </div>
                                    </div>
                                </Paper>
                            </Grid>
                        })
                    }
              </Grid>
    }
    render(){
        let featurs=this.renderFeatures();

        hljs.registerLanguage('javascript',javascript );
        // highlight with providing the language
        const highlightedCode = hljs.highlight('javascript', 'var a=10;for(i=0;i<10;i++)alert(a) console.log(a)').value


        return <div style={{marginTop:'75px',color:'white'}}>
            <Grid container  >
                <Grid item xs={12} sm={6} md={6} lg={6}> 
                    <div style={{background: '#0080ff'}}>
                                <div style={{display: 'flex',justifyContent: 'space-around',flexDirection: 'column',padding: '10px',alignItems: 'center',minHeight: '200px'}}>
                                <div style={{
                                        background: 'white',
                                        padding: '10px',
                                        border: '10px solid white',
                                        borderRadius: '50%'
                                }}>
                                    <img src='/logo.png' style={{
                                            width: '100px',
                                            height: '100px'
                                    }}/>
                                </div>
                                    <Typography variant='h3' color='inherit' >
                                        Actumjs
                                    </Typography>
                                    <Typography variant='h5' align='center'>
                                        A state management library for javascript app.
                                    </Typography>
                                </div>
                                <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center',padding: '10px'}}>

                                    <Button  variant='contained' size='large'>
                                        <LinkButton
                                        url={"/get-started"}
                                        text="Get started"
                                        />
                                    </Button>
                                </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} > 
                    <div  style={{ display:(window.screen.width<500)?'none':'flex',justifyContent:'center',alignItems:'center',height: '100%'}} >
                        <img src='/home_intro.svg' style={{width: '50%',height: '50%'}}/>
                    </div>
                </Grid>
            </Grid>
            {featurs}
        </div>
    }
}
export default Home;